import { render, staticRenderFns } from "./iban-reupload.vue?vue&type=template&id=21ccca44"
import script from "./iban-reupload.vue?vue&type=script&lang=js"
export * from "./iban-reupload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports